import React from "react";
import { string, func, bool, object, oneOfType } from "prop-types";
import DOMPurify from "dompurify";

import Icon from "../../../components/Icon/Icon.jsx";

const propTypes = {
  title: string,
  description: string,
  stat: object,
  returnToParentLabel: string,
  handleCloseChildMap: func,
  wideView: bool,
  backButtonRef: oneOfType([object, func]),
};

const MapHeading = (props) => {
  const {
    title,
    description,
    stat,
    returnToParentLabel,
    handleCloseChildMap,
    wideView,
    backButtonRef,
  } = props;

  return (
    <div className="map-heading">
      <div className="map-heading__intro">
        {title && <h2 className="map-heading__title">{title}</h2>}
        {description && (
          <div
            className="map-heading__description"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(description),
            }}
          ></div>
        )}
      </div>
      {stat && (
        <div className="map-heading__stat">
          {stat?.value && (
            <div
              className="map-heading__stat-value"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(stat.value),
              }}
            ></div>
          )}
          {stat?.description && (
            <div
              className="map-heading__stat-description"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(stat.description),
              }}
            ></div>
          )}
        </div>
      )}
      {returnToParentLabel && (
        <button
          ref={backButtonRef}
          className="map-heading__return-parent"
          onClick={handleCloseChildMap}
        >
          {!wideView && (
            <Icon
              iconName="arrow-left"
              className="multi-map__return-parent-icon"
            />
          )}
          {returnToParentLabel || "View world map"}
          {wideView && (
            <Icon
              iconName="collapse-content"
              className="multi-map__return-parent-icon"
            />
          )}
        </button>
      )}
    </div>
  );
};

MapHeading.propTypes = propTypes;
export default MapHeading;
